import * as React from 'react';

import { InjectedRouter } from 'react-router';

import { withRouter } from 'app/context/Router';
import ModalTrigger from 'components/ModalTrigger';
import Group from 'entities/Group';
import JoinGroupModal from 'groups/components/JoinGroupModal';
import Link from 'components/Link';
// @ts-ignore
import getRedirectLocationAfterGroupJoin from 'utils/getRedirectLocationAfterGroupJoin';

type Props = {
  router: InjectedRouter;
};

function NavigationListJoinGroupAction(props: Props) {
  const handleGroupJoined = (group: Group) => {
    props.router.push(getRedirectLocationAfterGroupJoin(group));
  };

  return (
    <ModalTrigger modal={<JoinGroupModal onJoin={handleGroupJoined} onRequestHide={() => {}} />}>
      <Link
        color="pitch"
        className="NavigationList-section-header"
        data-test-selector="join_class_nav_link"
        eventElementName="NavigationList-join-class"
        noHover>
        Join existing group
      </Link>
    </ModalTrigger>
  );
}

export { NavigationListJoinGroupAction };
export default withRouter(NavigationListJoinGroupAction);
